var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenBackgroundShirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "green-background-shirt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 30,
    height: 30,
    fill: "#09d05d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shirt",
    transform: "translate(6 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M22,4.5H19.7c-.125-.125-1.35-1.355-1.355-1.355A.565.565,0,0,0,18,3H11.5a.5.5,0,0,0-.355.145L9.795,4.5H8a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.5A2,2,0,0,0,22,4.5Zm-3.88-.175.78.785L16.8,9.725,15.645,8.86ZM17.16,4,14.965,8,12.41,4Zm-5.745.3L14.33,8.88l-1.17.875L10.62,5.09ZM23,21a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V6.5a1,1,0,0,1,1-1H9.7l2.855,5.24a.5.5,0,0,0,.74.16L15,9.625,16.7,10.9a.5.5,0,0,0,.755-.195L19.82,5.5H22a1,1,0,0,1,1,1Z",
    transform: "translate(-6 -3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 8.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 15.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBackgroundShirt);
export default __webpack_public_path__ + "static/media/green-background-shirt.70afaf0f9965d3063ddf2b5d8436bb27.svg";
export { ForwardRef as ReactComponent };